'use client';

import { Fragment } from 'react';
import Hero from '@/components/Hero';
import VideoTextCard from '@/components/VideoTextCard';
import card1Data from '../../../textContent/healthcare/card1Data.json';
import card2Data from '../../../textContent/healthcare/card2Data.json';
import { motion } from 'framer-motion';
/* ---------------- Animation Variant ---------------- */

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: 'easeOut',
        },
    },
};

const Page = () => {
    const heroTextContent = {
        heading: 'Ditch paperwork, automate tasks, focus on patients',
        caption:
            'ERPNext centralizes patient records, appointments, billing, and inventory management, reducing manual tasks and streamlining workflows.',
        image: '/images/hero/patient-appointment.png',
        buttonText: 'Contact Sales',
        buttonLink: '/contact-sales',
    };

    return (
        <Fragment>
            {/* Hero Section */}
            <motion.div variants={fadeUp} initial="hidden" animate="visible">
                <Hero {...heroTextContent} />
            </motion.div>

            {/* Card 1 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw] mb-5"
            >
                <VideoTextCard data={card1Data} />
            </motion.div>

            {/* Card 2 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw] mb-5"
            >
                <VideoTextCard data={card2Data} />
            </motion.div>
        </Fragment>
    );
};

export default Page;
